export const support = {
  contactUs: "联系我们",
  documentation: "文档",
  message: "留言",
  messageMaxLength: "最多可输入2000字",
  messagePlaceHolder: "请详细描述您的问题",
  pleaseInputMessage: "请留言",
  sendSuccessfully: "提交成功",
  submit: "提交",
  versionHistory: "历史版本",
  workxConnectAppDownload: "下载WorkX Connect应用",
};
